export default "__VITE_ASSET__C2kKdm1N__"